import { setUpPolicyAutoPayApi } from "./setUpPolicyAutoPayApi";

export default setUpPolicyAutoPayApi;
